const API = import.meta.env.VITE_API_URL || '';

export function api(path, opts = {}) {
  const hasBody = opts.body != null;
  const headers = hasBody ? { 'Content-Type': 'application/json' } : {};
  return fetch(`${API}${path}`, {
    ...opts,
    credentials: 'include',
    headers: { ...headers, ...opts.headers },
    body: hasBody ? JSON.stringify(opts.body) : undefined,
  }).then(async (r) => {
    const data = await r.json();
    if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
    return data;
  });
}

export const STAGES = ['neu', 'kontaktiert', 'termin_vereinbart', 'angebot_gesendet', 'gewonnen', 'verloren'];

// #1083 Phase 2/B — Stage-Farben Funnel-Flow konsistent zu SalesAnfragen.jsx
export const STAGE_COLORS = {
  neu: 'bg-amber-50 text-amber-700 border-amber-200',
  kontaktiert: 'bg-cyan-50 text-cyan-700 border-cyan-200',
  termin_vereinbart: 'bg-blue-50 text-blue-700 border-blue-200',
  angebot_gesendet: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  gewonnen: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  verloren: 'bg-rose-50 text-rose-700 border-rose-200',
};

export const SEGMENT_COLORS = {
  startup: 'bg-[var(--bg-inset)] text-[var(--text-secondary)]',
  midscale: 'bg-[#EBF4FD] text-[#338edc]',
  enterprise: 'bg-[#ECFEFF] text-[#0891B2]',
};

export const SENTIMENT_STYLE = {
  positiv:    { dot: 'bg-emerald-500', emoji: '🟢', label: 'Positive Stimmung' },
  negativ:    { dot: 'bg-red-500',     emoji: '🔴', label: 'Negative Stimmung' },
  rueckfrage: { dot: 'bg-amber-500',   emoji: '🟡', label: 'Rückfrage offen' },
  neutral:    { dot: 'bg-gray-400',    emoji: '⚪', label: 'Neutral' },
};

export function relTime(d) {
  if (!d) return '—';
  const ms = Date.now() - new Date(d).getTime();
  const s = Math.floor(ms / 1000);
  if (s < 60) return 'gerade eben';
  const m = Math.floor(s / 60);
  if (m < 60) return `vor ${m} Min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `vor ${h} Std`;
  const days = Math.floor(h / 24);
  if (days < 30) return `vor ${days} Tag${days === 1 ? '' : 'en'}`;
  const months = Math.floor(days / 30);
  return `vor ${months} Mon`;
}

export function fmtDate(d, opts = {}) {
  if (!d) return '—';
  const date = new Date(d);
  return date.toLocaleString('de-AT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', ...opts });
}

export const STAGE_LABEL = {
  neu: 'Neu',
  kontaktiert: 'Kontaktiert',
  termin_vereinbart: 'Termin vereinbart',
  angebot_gesendet: 'Angebot gesendet',
  gewonnen: 'Gewonnen',
  verloren: 'Verloren',
};
